enum ContractGroupLinkedType {
  ALL = 'ALL',
  LINKED = 'LINKED',
  NOT_LINKED = 'NOT_LINKED',
}

const contractGroupLinkedTypeOptions = [
  { text: 'Todos', value: ContractGroupLinkedType.ALL },
  { text: 'Vinculados a um grupo de contratos', value: ContractGroupLinkedType.LINKED },
  { text: 'Não vinculados a um grupo de contratos', value: ContractGroupLinkedType.NOT_LINKED },
]

export {
  ContractGroupLinkedType,
  contractGroupLinkedTypeOptions,
};
